<template>
<div class="registrationOfComponent">
  <box ref="box"></box>
  <el-card shadow="never" :style="style">
    <div class="titleBox">
      <div class="title">{{ $t('loopAutoRegister') }}</div>
    </div>
    <el-form :inline="true" ref="searchForm" class="search-form">
      <el-form-item :label="$t('panelNumber')">
        <el-input-number size="mini" v-model="searchForm.controllerNo" :min="0" :max="254"></el-input-number>
      </el-form-item>
      <el-form-item :label="$t('loopNo')">
        <el-input-number size="mini" v-model="searchForm.loopNo" :min="0" :max="254"></el-input-number>
      </el-form-item>
      <el-form-item>
        <el-checkbox  :label="$t('onlyAdd')" v-model="searchForm.autoRegisterType" name="type"></el-checkbox>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="_setLoopRegister(0)" :loading="loading0">{{$t('autoRegister')}}</el-button>
      </el-form-item>
    </el-form>
    <div class="titleBox">
      <div class="title">{{ $t('loopManualRegister') }}</div>
    </div>
    <el-form :inline="true" ref="searchForm" class="search-form">
      <el-form-item :label="$t('panelNumber')">
        <el-input-number size="mini" v-model="manualForm.controllerNo" :min="0" :max="254"></el-input-number>
      </el-form-item>
      <el-form-item :label="$t('loopNo')">
        <el-input-number size="mini" v-model="manualForm.loopNo" :min="0" :max="254"></el-input-number>
      </el-form-item>
      <el-form-item :label="$t('siteInitiation')">
        <el-input-number size="mini" v-model="manualForm.startCode" :min="0" :max="254"></el-input-number>
      </el-form-item>
      <el-form-item :label="$t('siteEnd')">
        <el-input-number size="mini" v-model="manualForm.endCode" :min="0" :max="254"></el-input-number>
      </el-form-item>
      <el-form-item style="float: right">
        <el-button type="primary" @click="_setManualRegister(1)" :loading="loading1">{{$t('manualRegister')}}</el-button>
      </el-form-item>
    </el-form>
    <el-form>
<!--      <el-form-item :label="$t('componentType')">
        <el-radio-group v-model="manualForm.devType">
          <el-radio :label="1">{{$t('foundationType')}}</el-radio>
          <el-radio :label="2">{{$t('customerType')}}</el-radio>
        </el-radio-group>
      </el-form-item>-->
      <el-form-item>
        <el-select v-model="manualForm.deviceType" :placeholder="$t('componentType')" filterable>
          <el-option
              v-for="item in deviceTypeOptions"
              :key="item.code"
              :label="item.name"
              :value="item.code">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </el-card>
</div>
</template>

<script>
import Box from "@/components/Box";
import {setLoopRegister} from "@/api/install"
import {mapState} from "vuex";
import Status from "components/Status";
export default {
  name: "autoAndManualRegister",
  mixins: [Status],
  components: {
    Box
  },
  data() {
    return {
      searchForm: {
        loopNo: '',
        controllerNo: '',
        autoRegisterType: true
      },
      manualForm: {
        loopNo: '',
        controllerNo: '',
        startCode: '',
        endCode: '',
        deviceType: ''
      },
      bottomHeight: null,
      style: null,
      loading0: false,
      loading1: false
    }
  },
  mounted() {
    this.calcHeight()
  },
  created(){
    this.searchForm.controllerNo = this.$store.state.controlInfo.controllerNo
    this.manualForm.controllerNo = this.$store.state.controlInfo.controllerNo
  },
  computed: {
    ...mapState({
      deviceTypeOptions: state => state.deviceTypeOptions
    }),
    controllInfo() {
      return this.$store.state.controlInfo
    }
  },
  methods: {
    calcHeight(){
      setTimeout(() => {
        this.bottomHeight = this.$refs.box.$el.clientHeight + 'px'
        this.style = `height: calc(100vh - 100px - ${this.bottomHeight})`
      }, 20)
    },
    _setLoopRegister(type) {
      this.loading0 = true
      this.show()
      let searchParams = {
        type: type,
        controllerPsn: this.controllInfo.controllerPsn,
        controllerNo: this.searchForm.controllerNo,
        loopNo: this.searchForm.loopNo
      }
      // 自动登记类型  1:重新登记，2：合并已有内容仅新增
      if (this.searchForm.autoRegisterType === true) {
        searchParams.autoRegisterType = 2
      } else {
        searchParams.autoRegisterType = 1
      }
      setLoopRegister(searchParams).then((res) => {
        if (res.code === 1) {
          this.loading0 = false
          this.success(res.message ? res.message : '操作成功')
        }
      }).catch(() => {
        this.loading0 = false
        this.failed()
      })
    },
    _setManualRegister(type) {
      this.loading1 = true
      this.show()
      if (this.manualForm.startCode === '') {
        this.$message.warning('请指定部件起始地址!')
        return
      }
      if (this.manualForm.endCode === '') {
        this.$message.warning('请指定部件结束地址!')
        return
      }
      let searchParams = {
        type: type,
        controllerPsn:  this.controllInfo.controllerPsn,
        controllerNo: this.manualForm.controllerNo,
        loopNo: this.manualForm.loopNo,
        startCode: this.manualForm.startCode,
        endCode: this.manualForm.endCode,
        deviceType: this.manualForm.deviceType
      }
      setLoopRegister(searchParams).then((res) => {
        if (res.code === 1) {
          this.loading1 = false
          this.success(res.message ? res.message : '操作成功')
        }
      }).catch(() => {
        this.loading1 = false
        this.failed()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.registrationOfComponent{
  .titleBox {
    .title {
      display: inline-block;
      font-weight: bold;
      font-size: 14px;
      font-family: MicrosoftYaHei-Bold;
      line-height: 30px;
      color: #2F4E68FF;
      margin-bottom: 10px;
    }
    .btn1, .btn2{
      float: right;
    }
    .btn2{
      margin-right: 20px;
    }
  }
}
</style>
